import React from "react";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { isWebpSupported } from "react-image-webp/dist/utils";
import * as S from "./HomeImageGalleryItem.styles";
import { ImageGalleryItem } from "Api/HomeImageGalleryApi";

export interface HomeImageGalleryItemProps extends ImageGalleryItem {
  channelTitle: string
  channelDescription: string
}

const HomeImageGalleryItem = (item: HomeImageGalleryItemProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const darkTitle = {
    textShadow: "0px 0px 5px #ffffff",
    color: "#282828"
  }
  const lightTitle = {
    textShadow: "2px 2px 5px #000000",
    color: "white"
  }
  return (
    <S.Container
      className={S.classes.root}
      style={{
        backgroundImage: `url("${
          isMobile
            ? `${item.mobilePhoto.url}${isWebpSupported ? "?fm=webp" : ""}`
            : `${item.desktopPhoto.url}${isWebpSupported ? "?fm=webp" : ""}`
        }")`,
      }}
    >
      <S.ImageOverlay />

      <S.Content>
        <Typography variant="display1" component="p" sx={{ whiteSpace: "normal" }}>
          {item.channelTitle}
        </Typography>

        <S.Details>
          <S.StationDescription variant={isMobile ? "h5" : "h3"} component="p" >
            {item.channelDescription || "Internet Radio"}
          </S.StationDescription>

          {(item.photoTitle || item.photoSubtitle) && (
            <S.Subtitle variant={isMobile ? "body2" : "h6"} component="p" style={item.photoTitleColor === "dark" ? darkTitle : lightTitle}>
              {item.photoTitle}
              <br />
              {item.photoSubtitle && (
                <S.Subtitle variant={isMobile ? "body2" : "caption"} component="span">
                  {item.photoSubtitle}
                </S.Subtitle>
              )}
            </S.Subtitle>
          )}
        </S.Details>
      </S.Content>
    </S.Container>
  );
};

export default HomeImageGalleryItem;
